import {ReflexiveRestModel} from 'src/lib/reflexive-model/reflexive-rest-model';
import {FieldType} from 'src/lib/reflexive-model/field-type.enum';
import {Validators} from '@angular/forms';
import {floatValidator} from '../../../../lib/validator/float.validator';
import {numberGreaterThanZeroValidator} from '../../../../lib/validator/numberGreaterThanZero.validator';
export class TopUpBalanceUsingBankCardModel extends ReflexiveRestModel {

  constructor() {
    super();
    this.fields = {
      amount: {
        type: FieldType.FloatField,
        label: 'Top-up amount',
        value: null,
        validators: [floatValidator, Validators.required, numberGreaterThanZeroValidator],
      },
      amountInBankCardCurrency: {
        type: FieldType.FloatField,
        label: 'Payment amount',
        value: null,
        validators: [floatValidator, Validators.required, numberGreaterThanZeroValidator],
      },
    };
  }
}
